(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-modal"]) return;
  try {
    
class CartModalRecommendations extends HTMLElement {
  connectedCallback() {
    if (this.dataset.loaded === 'true') return;
    this.dataset.loaded = 'true';

    const productTypes = (this.dataset.productTypes || '').split('|').filter(Boolean);
    const keywordByProductType = {
      'vitaminer-mineraler': 'Magnesium',
      'kosttillskott': 'Magnesium',
      'vitamins-minerals-health': 'Magnesium',
      'immunforsvar': 'D-vitamin',
      'stress-balans': 'Magnesium',
      'somn': 'Magnesium',
      'somnhalsa': 'Magnesium',
      'magnesium': 'Ashwagandha',
      'mage-tarm': 'Probiotika',
      'ledhalsa-kollagen': 'Omega 3',
      'omega-fettsyror': 'D-vitamin',
      'aminosyror': 'Elektrolyter',
      'amino-acids': 'Elektrolyter',
      'bcaa': 'Elektrolyter',
      'eaa': 'Elektrolyter',
      'pre-workout': 'Elektrolyter',
      'pwo': 'Elektrolyter',
      'traning': 'Elektrolyter',
      'proteinpulver': 'Kreatin',
      'vassleprotein': 'Kreatin',
      'vassleprotein-whey': 'Kreatin',
      'kaseinprotein': 'Kreatin',
      'veganskt-proteinpulver': 'Kreatin',
      'kreatin': 'Proteinpulver',
      'kreatine': 'Proteinpulver',
      'energi-fokus': 'Magnesium'
    };
    const keyword = productTypes.map((type) => keywordByProductType[type]).find(Boolean);

    if (!keyword) {
      this.remove();
      return;
    }

    this.loadKeywordRecommendations(keyword)
      .then((recommendations) => {
        if (recommendations) this.replaceWith(recommendations);
        else this.remove();
      })
      .catch(() => this.remove());
  }

  async loadKeywordRecommendations(keyword) {
    const url = new URL(window.routes.search_url || '/search', window.location.origin);
    url.searchParams.set('section_id', 'cart-modal-keyword-recommendations');
    url.searchParams.set('q', keyword);
    url.searchParams.set('type', 'product');

    const response = await fetch(url.toString());
    if (!response.ok) return null;

    const html = await response.text();
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    return documentFragment.querySelector('.cart-modal-keyword-recommendations');
  }
}

if (!customElements.get('cart-modal-recommendations')) {
  customElements.define('cart-modal-recommendations', CartModalRecommendations);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hv-buying-guides"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hv-guide-picker')) {
    customElements.define('hv-guide-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const cards = [...this.querySelectorAll('[data-guide]')];
        if (cards.length < 2) return;
        const choices = this.querySelector('.hv-guides__choices');
        const buttons = cards.map(card => {
          const button = document.createElement('button');
          button.type = 'button';
          button.textContent = card.dataset.guideLabel;
          button.setAttribute('aria-controls', card.id);
          choices.append(button);
          return button;
        });
        const select = index => {
          cards.forEach((card, i) => { card.hidden = i !== index; buttons[i].setAttribute('aria-pressed', String(i === index)); });
        };
        buttons.forEach((button, i) => button.addEventListener('click', () => select(i)));
        this.addEventListener('shopify:block:select', event => {
          const index = cards.findIndex(card => card.contains(event.target));
          if (index >= 0) select(index);
        });
        this.querySelector('.hv-guides__cards').dataset.enhanced = '';
        choices.hidden = false;
        select(0);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
